export default "__VITE_ASSET__IlXu$bUg__"